import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function SshUsernameField({ sshUsername, passwordlessKeyActive, centralCredential, error, disabled }) {

    const [disableValue, setDisableValue] = useState(disabled)

    useEffect(() => {
        if (passwordlessKeyActive) {
            validationService.cleanValidation('sshUsername');
        } else {
            validationService.validateUsername(sshUsername, 'sshUsername');
        }
        return () => validationService.cleanValidation('sshUsername');
    }, [sshUsername, passwordlessKeyActive])

    useEffect(() => {
        if(centralCredential && centralCredential.id > 0) {
            setDisableValue(true);
        }
        else {
            setDisableValue(false);
        }
        // validationService.validateUsername(sshUsername, 'sshUsername');
        // return () => validationService.cleanValidation('sshUsername');
    }, [centralCredential])

    const onChange = (value) => modalDataService.changeSshUsername(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="ssh_username-key">Username <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ssh_username-key"
                    disabled={disableValue || disabled}
                    value={sshUsername}
                    placeholder="admin"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("SshPaswordlessKeyField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        sshUsername: addDeviceModal.sshUsername || '',
        centralCredential: addDeviceModal.centralCredential || null,
        error: validation.sshUsername,
    }
}

export default connect(mapStateToProps)(SshUsernameField);